import React, { useEffect, useState } from "react";
import axios from "axios";
import progressGif from "../../images/progress.gif"; 

function Ekyc_Failed_DataList() {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1; 

  const [months, setMonths] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth.toString());
  const [selectedYear, setSelectedYear] = useState(currentYear.toString());
  const [aadhar, setAadhar] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/ekyc/months`)
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch months");
        return response.json();
      })
      .then((data) => {
        setMonths(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });

    let maxYear = currentYear + 1;
    const yearsArr = [];
    for (let i = 2019; i <= maxYear; i++) {
      yearsArr.push(i.toString());
    }
    setYears(yearsArr);
  }, [currentYear]);

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!selectedMonth) {
    alert("Please select a month");
    return;
  }

  if (!selectedYear) {
    alert("Please select a year");
    return;
  }

  const aadharTrimmed = aadhar.trim();

  if (aadharTrimmed.length !== 12) {
    alert("Aadhar number must be exactly 12 digits");
    return;
  }

  const aadharRegex = /^\d{12}$/;
  if (!aadharRegex.test(aadharTrimmed)) {
    alert("Enter valid Aadhar number");
    return;
  }

  setFetching(true);

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_URL}/api/ekyc/ekycFailedDataList`,
      {
        params: {
          month: parseInt(selectedMonth, 10),
          year: parseInt(selectedYear, 10),
          uid: aadharTrimmed,
        },
      }
    );

    console.log("API Response:", response.data);
    setTableData(response.data);

    if (response.data.length === 0) {
      alert("No data found for these inputs");
    }
  } catch (err) {
    console.error("Error fetching data:", err);
    alert("Failed to fetch data");
  }

  setFetching(false);
};


  const formatDate = (dateString) => {
    const d = new Date(dateString);
    const pad = (num, size = 2) => num.toString().padStart(size, "0");

    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());
    const seconds = pad(d.getSeconds());
    const milliseconds = pad(d.getMilliseconds(), 3);

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  };

  if (loading) return <p>Loading months...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div className="wrapper row3">
      <div
        id="container"
        style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <form onSubmit={handleSubmit} style={{ width: "50%" }}>
          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "black", color: "white" }}>
                <th colSpan={6} style={{ padding: "10px", textAlign: "center", fontSize:'25px' }}>
                  EKYC Failed Details
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ backgroundColor: "#f9f9f9" }}>
                <td style={{ padding: "10px", fontSize:'20px' }}>Month</td>
                <td>
                  <select
                       value={selectedMonth}
                       onChange={(e) => setSelectedMonth(e.target.value)}
                       required
                    style={{ 
                    padding: "5px", 
                    width: "100%", 
                   fontSize: "15px"  
  }}
>
  {months.map((m) => (
    <option key={m.month} value={m.month}>
      {m.name}
    </option>
  ))}
</select>
  </td>

                <td style={{ padding: "8px", fontSize:'20px' }}>Year</td>
                <td>
                 <select
  value={selectedYear}
  onChange={(e) => setSelectedYear(e.target.value)}
  style={{ 
    padding: "5px", 
    width: "100%", 
    fontSize: "15px"  
  }}
>
  {years.map((y) => (
    <option key={y} value={y}>
      {y}
    </option>
  ))}
</select>
 </td>

                <td style={{ padding: "8px", fontSize:'20px' }}>Aadhar Number</td>
                <td>
                 <input
  type="text"
  value={aadhar}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, ""); // allow only numbers
    setAadhar(value);
  }}
  required
  maxLength={12}
  style={{
    border: "1px solid black",
    padding: "5px",
    width: "100%",
    outline: "none",
    transition: "border 0.3s",
    fontSize: "15px",
  }}
  onFocus={(e) => (e.target.style.border = "2px solid black")}
  onBlur={(e) => (e.target.style.border = "1px solid black")}
  onKeyDown={(e) => {
    if (e.key === "Enter") e.preventDefault()
  }}
/>
                </td>
              </tr>
              <tr>
                <td colSpan={6} style={{ textAlign: "center", padding: "10px" }}>
                <button
  type="submit"
  style={{
    padding: "6px 15px",
    borderRadius: "10px",
    border: "none",
    backgroundColor: "black",
    color: "white",
    cursor: "pointer",
    marginRight: "10px",
  }}
>
  Submit
</button>
                  <button
                    type="button"
                    onClick={() => setTableData([])}
                    style={{
                      padding: "6px 15px",
                      borderRadius: "10px",
                      border: "none",
                      backgroundColor: "black",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    Back
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </form>

        {fetching && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <img src={progressGif} alt="Loading..." width="250" height="15" />
          </div>
        )}
        {tableData && tableData.length > 0 && (
          <table
            border="1"
            style={{
              borderCollapse: "collapse",
              width: "70%",
              marginTop: "60px",
              fontSize: "18px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "black", color: "white" }}>
                <th style={{ padding: "12px 15px" }}>Sl No</th> 
                <th style={{ padding: "12px 15px" }}>District</th>
                <th style={{ padding: "12px 15px" }}>AFSO</th>
                <th style={{ padding: "12px 15px" }}>Shop No</th>
                <th style={{ padding: "12px 15px" }}>RC ID</th>
                <th style={{ padding: "12px 15px" }}>Inserted Time</th>
                <th style={{ padding: "12px 15px" }}>EKYC UID</th>
                <th style={{ padding: "12px 15px" }}>Response Message</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  <td style={{ padding: "10px 15px"}}>{index + 1}</td> 
                  <td style={{ padding: "10px 15px" }}>{row.distNameEn}</td>
                  <td style={{ padding: "10px 15px" }}>{row.afsoNameEn}</td>
                  <td style={{ padding: "10px 15px" }}>{row.shopNo}</td>
                  <td style={{ padding: "10px 15px" }}>{row.rcId}</td>
                  <td style={{ padding: "10px 15px" }}>{formatDate(row.insTime)}</td>
                  <td style={{ padding: "10px 15px" }}>{row.ekycUid}</td>
                  <td style={{ padding: "10px 15px" }}>{row.respMessage}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Ekyc_Failed_DataList;
